@let controls = form().controls;

<pai-input-field [label]="'ContactForm.Name.Label' | translate" [appearance]="appearance()">
  <input type="text" [formControl]="controls.name" autocomplete="name" />
</pai-input-field>

<pai-input-field [label]="'ContactForm.Email.Label' | translate" [appearance]="appearance()">
  <input type="email" [formControl]="controls.email" autocomplete="email" />
</pai-input-field>

<pai-input-field [label]="'ContactForm.Message.Label' | translate" [appearance]="appearance()">
  <textarea [formControl]="controls.message" paiAutosize [rows]="3"></textarea>
</pai-input-field>
